import { render, staticRenderFns } from "./PhraseGeneratorComponent.vue?vue&type=template&id=0cad60c4&scoped=true"
import script from "./PhraseGeneratorComponent.vue?vue&type=script&lang=js"
export * from "./PhraseGeneratorComponent.vue?vue&type=script&lang=js"
import style0 from "./PhraseGeneratorComponent.vue?vue&type=style&index=0&id=0cad60c4&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cad60c4",
  null
  
)

export default component.exports